document.addEventListener('DOMContentLoaded', function() {
    // 1. Намираме всички продуктови секшъни на страницата
    const productSections = document.querySelectorAll('product-form');

    // 2. Завъртаме цикъл, за да инициализираме логиката ЗА ВСЕКИ СЕКШЪН ОТДЕЛНО
    productSections.forEach(function(section) {
        
        // Търсим опциите и бутона САМО вътре в текущия секшън (section.querySelector вместо document.querySelector)
        const productOptions = section.querySelectorAll('.product-ovii--option');
        if (productOptions.length === 0) return; // Ако в този секшън няма абонаментен уиджет, пропускаме го

        const checkoutButton = section.querySelector('.btn-checkout');
        let selectedOption = null;

        // Gallery image override setup - Търсим снимките само в текущия секшън
        const firstSlide = section.querySelector('.slider__item[data-media-id]');
        const firstSlideLink = firstSlide?.querySelector('.show-gallery');
        const firstSlideImg = firstSlide?.querySelector('img');
        const firstThumb = section.querySelector('.thumbnails .slider__item[data-media-id]');
        const firstThumbImg = firstThumb?.querySelector('img');

        // Store original image data for THIS specific section
        const originalImageData = firstSlide && firstSlideImg ? {
            mainHref: firstSlideLink?.getAttribute('href'),
            mainSrc: firstSlideImg.getAttribute('src'),
            mainSrcset: firstSlideImg.getAttribute('srcset'),
            mainAlt: firstSlideImg.getAttribute('alt'),
            thumbSrc: firstThumbImg?.getAttribute('src'),
            thumbSrcset: firstThumbImg?.getAttribute('srcset')
        } : null;

        function updateGalleryImage(option) {
            if (!originalImageData || !firstSlide) return;

            const overrideUrl = option?.dataset.firstImageOverride;
            const overrideSrcset = option?.dataset.firstImageOverrideSrcset;
            const overrideThumb = option?.dataset.firstImageOverrideThumb;
            const overrideThumbSrcset = option?.dataset.firstImageOverrideThumbSrcset;

            if (overrideUrl && overrideSrcset) {
                // Update main carousel image
                if (firstSlideLink) firstSlideLink.setAttribute('href', overrideUrl);
                if (firstSlideImg) {
                    firstSlideImg.setAttribute('src', overrideUrl);
                    firstSlideImg.setAttribute('srcset', overrideSrcset);
                }

                // Update thumbnail
                if (firstThumbImg && overrideThumb && overrideThumbSrcset) {
                    firstThumbImg.setAttribute('src', overrideThumb);
                    firstThumbImg.setAttribute('srcset', overrideThumbSrcset);
                }
                
                // Ensure the browser has registered the src change before showing
                if (firstSlideImg) {
                    firstSlideImg.style.opacity = '1';
                }
            } else {
                // Restore original images
                if (firstSlideLink) firstSlideLink.setAttribute('href', originalImageData.mainHref);
                if (firstSlideImg) {
                    firstSlideImg.setAttribute('src', originalImageData.mainSrc);
                    firstSlideImg.setAttribute('srcset', originalImageData.mainSrcset);
                }
                if (firstThumbImg) {
                    firstThumbImg.setAttribute('src', originalImageData.thumbSrc);
                    firstThumbImg.setAttribute('srcset', originalImageData.thumbSrcset);
                }
            }
        }

        function updateButton() {
            if (!checkoutButton) return;
            if (selectedOption) {
                // Enable the button since we have a selection
                checkoutButton.removeAttribute('disabled');
                checkoutButton.classList.remove('is-loading');
            } else {
                checkoutButton.setAttribute('disabled', 'true');
            }
        }

        function removeActiveClass() {
            productOptions.forEach(option => {
                option.classList.remove('option--active');
            });
        }

        function selectOption(option) {
            removeActiveClass();
            option.classList.add('option--active');
            selectedOption = option;
            updateButton();
            updateGalleryImage(option);
        }

        productOptions.forEach(option => {
            option.addEventListener('click', function() {
                selectOption(this);
            });
        });

        // Add to cart functionality
        if (checkoutButton) {
            checkoutButton.addEventListener('click', async function(evt) {
                evt.preventDefault();
                
                if (!selectedOption) {
                    console.log('No option selected');
                    return;
                }

                // Disable button and show loading state
                this.setAttribute('disabled', 'true');
                this.classList.add('is-loading');

                try {
                    const variantId = selectedOption.dataset.variantId;
                    const quantity = parseInt(selectedOption.dataset.qty) || 1;
                    const sellingPlan = selectedOption.dataset.sellingPlan;

                    // Prepare cart add data
                    const cartData = {
                        items: [{
                            id: parseInt(variantId),
                            quantity: quantity
                        }]
                    };

                    // Add selling plan if present (for subscriptions)
                    if (sellingPlan) {
                        cartData.items[0].selling_plan = parseInt(sellingPlan);
                    }

                    // Add to cart using Shopify Cart API
                    const response = await fetch('/cart/add.js', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            'Accept': 'application/json'
                        },
                        body: JSON.stringify(cartData)
                    });

                    const result = await response.json();

                    if (!response.ok) {
                        throw new Error(result.description || result.message || 'Failed to add to cart');
                    }

                    // Trigger cart change event to update cart UI
                    document.dispatchEvent(
                        new CustomEvent('on:cart:change', { bubbles: true, cancelable: false })
                    );

                    // Show success state
                    this.classList.add('is-success');
     
                    // Handle different cart behaviors based on theme settings
                    if (theme.settings.afterAddToCart === 'drawer') {
                        // Open cart drawer if theme uses drawer
                        document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open'));
                    } else if (theme.settings.afterAddToCart === 'page') {
                        // Redirect to cart page
                        setTimeout(() => {
                            window.location.href = '/cart';
                        }, 500);
                    } else if (theme.settings.afterAddToCart === 'notification') {
                        // Show notification (theme will handle this via the cart change event)
                        // todo add functionality if needed
                    }

                    // Reset button state after 2 seconds
                    setTimeout(() => {
                        this.classList.remove('is-loading', 'is-success');
                        this.removeAttribute('disabled');
                    }, 2000);

                } catch (error) {
                    console.error('Error adding to cart:', error);
                    
                    // Show error message (you can customize this)
                    alert('Error adding item to cart');
                    
                    // Reset button state
                    this.classList.remove('is-loading');
                    this.removeAttribute('disabled');
                }
            });
        }

        // Select the first option by default
        if (productOptions.length > 0) {
            selectOption(productOptions[0]);
        }
    });
});